import ApiCallerClient, {ApiMethod} from "../clients/apiCallerClient";

export default class ImageUploader {
  constructor(apiHost) {
    this.apiHost = apiHost;
  }

  async uploadImageToS3(file, fileName = null) {
    try {
      // Compress to stay under 4.5MB (6MB - 33% base64 overhead)
      const compressedFile = await this.compressIfNeeded(file);
      const base64Data = await this.fileToBase64(compressedFile);
      const key = fileName || `images/${Date.now()}-${file.name || 'image.jpg'}`;
      
      const path = `/default`;
      let response = await ApiCallerClient.callApi({
        "endpoint": {
          "hostName": this.apiHost,
          "httpMethod": ApiMethod.POST,
          "path": path
        },
        "body": JSON.stringify({
          "purpose": "IMAGE_UPLOAD",
          "imageData": base64Data,
          "imageFileName": key,
          "contentType": compressedFile.type
        })
      });
      
      const result = response?.body ? JSON.parse(response.body) : {};
      console.log('Image uploaded successfully:', result.url);
      return result.url;
    } catch (error) {
      console.error('Image upload failed:', error);
      throw error;
    }
  }

  async compressIfNeeded(file) {
    const maxSize = 4.5 * 1024 * 1024; // 4.5MB to account for base64 overhead
    if (file.size <= maxSize) return file;
    
    return new Promise((resolve) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();
      
      img.onload = () => {
        const ratio = Math.sqrt(maxSize / file.size);
        canvas.width = img.width * ratio;
        canvas.height = img.height * ratio;
        
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        canvas.toBlob(resolve, 'image/jpeg', 0.8);
      };
      
      img.src = URL.createObjectURL(file);
    });
  }

  fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(',')[1]);
      reader.onerror = error => reject(error);
    });
  }
}